<template>
  <div>
    <H5TabList v-if="isH5" />
    <PcTabList v-else />
  </div>
</template>

<script>
import PcTabList from "./pc/TabList.vue";
import H5TabList from "./mobile/TabList";
import { isH5 } from "@saas/components/src";
export default {
  data: function () {
    return {
      isH5: isH5(),
    };
  },
  components: {
    H5TabList,
    PcTabList,
  },
};
</script>

<style lang="scss" scoped></style>
